// extracted by mini-css-extract-plugin
export default {"bottomShadow":"ErrorPage_bottomShadow__1oGJR","errorPage":"ErrorPage_errorPage__iptxb","errorImage":"ErrorPage_errorImage__qkpqV","backButton":"ErrorPage_backButton__HuWcl"};